import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import NatTokenRepo from '../token/repository/NatTokenRepo'
import NatRoomToResidentRepo from '../roomToResident/repository/NatRoomToResidentRepo'
import NatResidentUserRepo, {
    ResidentUserAuthedRequest,
    ResidentUserConfirmRequest,
} from '../residentUser/repository/NatResidentUserRepo'
import {NatGetResidentUserAuthenticationKey} from '../residentUser/repository/NatGetResidentUserAuthenticationKey'
import {NatGetToken} from '../token/repository/NatGetToken'
import {DO_OR_NOT, FIRST_LOGIN_REFERRER_ID, VALID_OR_NOT} from '../../../CodeMaster'
import {getQueryParameter, NatAsyncCallFunction} from '../../common/util/Natutil'
import styled from 'styled-components'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    Note,
    ParagraphText,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {StyledDiv} from '../../../styledComponents/StyledTypeDefinitions'
import {
    DisplayBlockDiv,
    DisplayCheckItemSelectionLabel,
    DisplayCheckItemSelectionName,
    DisplayItemInput,
    DisplayItemInputLabelRequired,
    DisplayItemInputTitle,
    DisplayItemInputTitleRequired,
    TitleErrorLabel,
} from '../../../styledComponents/DisplayItem'
import {Colors, FontSize} from '../../../styledComponents/Constants'
import {PlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {Messages} from '../../../Messages'
import {Nullable} from '../../../app/TypeHelpers'
import {ErrorResponseBody} from '../../../network/response/ErrorResponseBody'
import {BaseHttpError} from '../../../network/errors/baseHandling/BaseHttpError'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Box, Checkbox} from '@mui/material'
import {LeftRowFlexContainer} from '../../../styledComponents/FlexComponents'
import {BlockSpacer, currentMedia} from '../../../styledComponents/ResponsiveConvenience'
import {OpenInNew} from '@mui/icons-material'
import {HKConstants} from '../../../HKConstants'
import {NatGetRoomToResidentAuthenticationKey} from '../roomToResident/repository/NatGetRoomToResidentAuthenticationKey'
import {Location} from 'react-router-dom'

interface FirstLoginLocationState {
    firstLoginReferrerId: string
    dIspStepInfo: DIspStepInfo
    policyAgreeType: string
    residentUserType: string
    authenticationKey: string
    firstLoginUserInfoInput: {
        parentResidentId: string,
        condominiumName: string,
        ridgeName: string,
        roomNumber: string,
        policyAgreeType: string,
        familyName: string,
        firstName: string,
        familyNameKana: string,
        firstNameKana: string,
        sex: string,
        mailAddress: string,
        birthday: string,
        wishToHasekoGroupInfos: string,
        wishToHasekoGroupInfosDispFlg: boolean,
        sutekiNetOfNotice: string,
    }
}

interface Props {
    tokenRepo: NatTokenRepo,
    residentUserRepo: NatResidentUserRepo,
    roomToResidentRepo: NatRoomToResidentRepo,
    location: Location<FirstLoginLocationState>
}

interface States {
    token: NatGetToken,
    condominiumData: NatGetRoomToResidentAuthenticationKey,
    hasekoIdLoginButtonFlg: boolean,
    password: string,
    dispPassword: string,
    wishToHasekoGroupInfos: string
    sutekiNetOfNotice: string
    errorTitleMessage: string,
    isLoadCompleted: boolean,
}

class NatResidentFirstLoginSutekiPasswordConfirmPage extends Component<Props & ResidentPagePropsSet, States> {
    firstLoginLocationState: FirstLoginLocationState
    queryToken: string
    isOwnershipTransfer: boolean
    dIspStepInfo: DIspStepInfo

    constructor(props: Props & ResidentPagePropsSet) {
        super(props)
        this.state = {
            token: {
                details: {
                    token: '',
                    sutekiNetId: '',
                    mailAddress: '',
                    authenticationKey: '',
                    parentResidentId: '',
                    policyAgreeType: '',
                    referenceId: '',
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    familyName: '',
                    firstName: '',
                    familyNameKana: '',
                    firstNameKana: '',
                    freeSettingItem: '',
                    flpExistFlag: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            condominiumData: {
                details: {
                    condominiumCd: '',
                    condominiumName: '',
                    ridgeCd: '',
                    ridgeName: '',
                    roomNumber: '',
                    parentResidentId: '',
                    receivingAgencyCd: '',
                },
                informations: null,
                requestError: null,
                requestItemErrors: null,
            },
            hasekoIdLoginButtonFlg: true,
            password: '',
            wishToHasekoGroupInfos: DO_OR_NOT.DO.value,
            sutekiNetOfNotice: DO_OR_NOT.DO.value,
            dispPassword: VALID_OR_NOT.NOT.value,
            errorTitleMessage: '',
            isLoadCompleted: false,
        }
        const locationState = this.props.location.state
        // @ts-ignore
        this.firstLoginLocationState = (locationState) ? locationState.firstLoginLocationState : []
        this.queryToken = getQueryParameter('token', this.props.location.search)
        this.isOwnershipTransfer = new URLSearchParams(this.props.location.search).has('ownershipTransfer')
        this.dIspStepInfo = {
            sutekiNetPasswordConfirm: true,
            userConfirm: true,
            complete: true,
        }

        this.systemErrorTransition = this.systemErrorTransition.bind(this)
        this.handleInputChange = this.handleInputChange.bind(this)
        this.handlePassworDispTypeChange = this.handlePassworDispTypeChange.bind(this)
        this.hasekoIdLoginButtonClick = this.hasekoIdLoginButtonClick.bind(this)
    }

    async componentDidMount(): Promise<void> {
        const systemErrorMessageId =
            this.isOwnershipTransfer ? Messages.ERESR0013.toString() : Messages.ERESR0003.toString()

        // トークンチェック
        if (this.queryToken === '') {
            this.props.navigate('/resident/error', {
                state: {
                    message: systemErrorMessageId,
                    nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                },
            })
            return
        }

        await this.props.eventEmitter.showLoading()
        try {
            const retToken: Nullable<NatGetToken> = await NatAsyncCallFunction(
                this.props.tokenRepo.getToken.bind(
                    this.props.tokenRepo, this.queryToken), this.props.navigate, this.systemErrorTransition)

            if (retToken && retToken.details === null) {
                this.props.navigate('/resident/error', {
                    state: {
                        message: systemErrorMessageId,
                        nonDisplayBackBtnFlag: this.isOwnershipTransfer,
                    },
                })
                return
            } else if (retToken && retToken.details) {
                // ブランシエラクラブ　初期値
                let wishToHasekoGroupInfos: string = this.state.wishToHasekoGroupInfos
                // 　入力情報が存在する場合
                if (this.firstLoginLocationState.firstLoginUserInfoInput) {
                    wishToHasekoGroupInfos =
                        this.firstLoginLocationState.firstLoginUserInfoInput.wishToHasekoGroupInfos
                }
                const condominiumData: Nullable<NatGetRoomToResidentAuthenticationKey> = await NatAsyncCallFunction(
                    this.props.roomToResidentRepo.getRoomToResidentByAuthenticationKey.bind(
                        this.props.roomToResidentRepo, retToken.details.authenticationKey),
                    this.props.navigate,
                    this.systemErrorTransition,
                )
                if (condominiumData) {
                    this.setState({
                        token: retToken,
                        condominiumData: condominiumData,
                        wishToHasekoGroupInfos: wishToHasekoGroupInfos,
                        sutekiNetOfNotice: this.firstLoginLocationState.firstLoginUserInfoInput ?
                            this.firstLoginLocationState.firstLoginUserInfoInput.sutekiNetOfNotice :
                            this.state.sutekiNetOfNotice,
                    })
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
            this.setState({isLoadCompleted: true})
        }
    }

    // システムエラー遷移
    systemErrorTransition(): void {
        this.props.navigate(`/resident/error`, {
            state: {
                message: Messages.ESYCC0018.toString(),
                nonDisplayBackBtnFlag: this.isOwnershipTransfer,
            },
        })
    }

    // 入力
    handleInputChange(event: React.ChangeEvent<HTMLInputElement>): void {
        let password: string = this.state.password
        let wishToHasekoGroupInfos: string = this.state.wishToHasekoGroupInfos
        let sutekiNetOfNotice: string = this.state.sutekiNetOfNotice

        // 入力項目
        switch (event.target.name) {
            case 'password':
                password = event.target.value
                break
            case 'wishToHasekoGroupInfos':
                wishToHasekoGroupInfos = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
                break
            case 'sutekiNetOfNotice':
                sutekiNetOfNotice = (event.target.checked) ? DO_OR_NOT.DO.value : DO_OR_NOT.NOT.value
                break
            default:
                break
        }

        this.setState({
            password: password,
            wishToHasekoGroupInfos: wishToHasekoGroupInfos,
            sutekiNetOfNotice: sutekiNetOfNotice,
            hasekoIdLoginButtonFlg: password === '',
        })
    }

    // パスワードを表示する
    handlePassworDispTypeChange(event: React.ChangeEvent<HTMLInputElement>): void {
        if (event.target.checked) {
            this.setState({dispPassword: VALID_OR_NOT.VALID.value})
        } else {
            this.setState({dispPassword: VALID_OR_NOT.NOT.value})
        }
    }

    // 登録する
    async hasekoIdLoginButtonClick(): Promise<void> {
        if (this.state.token.details === null ||
            this.state.condominiumData.details === null) {
            return
        }

        await this.props.eventEmitter.showLoading()
        try {
            // ユーザ認証
            const authRequest: ResidentUserAuthedRequest = {
                mailAddress: this.state.token.details.mailAddress,
                password: this.state.password,
                authenticationKey: this.state.token.details.authenticationKey,
                token: ``,
            }
            const authenticationInfo: Nullable<NatGetResidentUserAuthenticationKey> = await NatAsyncCallFunction(
                this.props.residentUserRepo.getResidentUserAuthed.bind(
                    this.props.residentUserRepo, authRequest), this.props.navigate, this.systemErrorTransition)

            if (authenticationInfo === null) {
                this.setTitleErrorMessage(Messages.ERESR0005.toString())
                return
            }
            if (authenticationInfo.details === null) {
                this.setTitleErrorMessage(Messages.ERESR0005.toString())
                return
            }

            try {
                const birthday: string[] = authenticationInfo.details.residentUserInfo.birthday.split('-')
                // 居住者ユーザ登録確認
                const confirmRequest: ResidentUserConfirmRequest = {
                    familyName: authenticationInfo.details.residentUserInfo.familyName,
                    firstName: authenticationInfo.details.residentUserInfo.firstName,
                    familyNameKana: authenticationInfo.details.residentUserInfo.familyNameKana,
                    firstNameKana: authenticationInfo.details.residentUserInfo.firstNameKana,
                    birthdayYear: birthday[0],
                    birthdayMonth: birthday[1],
                    birthdayDay: birthday[2],
                    sex: authenticationInfo.details.residentUserInfo.sex,
                    password: this.state.password,
                    wishToHasekoGroupInfos: ``,
                    sutekiNetOfNotice: this.state.sutekiNetOfNotice,
                }
                await NatAsyncCallFunction(
                    this.props.residentUserRepo.residentUserConfirm.bind(
                        this.props.residentUserRepo, confirmRequest), this.props.navigate, this.systemErrorTransition)
                this.props.navigate(
                    `/resident/firstLoginUserInfoConfirm?token=${this.queryToken}`,
                    {
                        state: {
                            firstLoginLocationState: {
                                firstLoginReferrerId: FIRST_LOGIN_REFERRER_ID.SUTEKI_PASSWORD_CONFIRM.value,
                                policyAgreeType: this.state.token.details.policyAgreeType,
                                firstLoginUserInfoInput: {
                                    hasekoId: authenticationInfo.details.residentUserInfo.hasekoId,
                                    parentResidentId: this.state.token.details.parentResidentId,
                                    condominiumCd: this.state.condominiumData.details.condominiumCd,
                                    condominiumName: this.state.condominiumData.details.condominiumName,
                                    ridgeName: this.state.condominiumData.details.ridgeName,
                                    roomNumber: this.state.condominiumData.details.roomNumber,
                                    policyAgreeType: this.state.token.details.policyAgreeType,
                                    familyName: authenticationInfo.details.residentUserInfo.familyName,
                                    firstName: authenticationInfo.details.residentUserInfo.firstName,
                                    familyNameKana: authenticationInfo.details.residentUserInfo.familyNameKana,
                                    firstNameKana: authenticationInfo.details.residentUserInfo.firstNameKana,
                                    birthday: authenticationInfo.details.residentUserInfo.birthday,
                                    mailAddress: this.state.token.details.mailAddress,
                                    sex: authenticationInfo.details.residentUserInfo.sex,
                                    wishToHasekoGroupInfos: this.state.wishToHasekoGroupInfos,
                                    wishToHasekoGroupInfosDispFlg: true,
                                    sutekiNetOfNotice: this.state.sutekiNetOfNotice,
                                    receivingAgencyCd: this.state.condominiumData.details.receivingAgencyCd,
                                    isOwnershipTransfer: this.isOwnershipTransfer,
                                },
                                dIspStepInfo: this.dIspStepInfo,
                            },
                        },
                    },
                )
            } catch (HttpError) {
                // 連携対象の会員情報が不足
                this.setTitleErrorMessage(Messages.ERESR0010.toString())
                return
            }
        } catch (HttpError) {
            const errorResponseBody: Nullable<ErrorResponseBody> = (HttpError as BaseHttpError).responseBody
            if (errorResponseBody !== null) {
                if (errorResponseBody.requestError !== null) {
                    this.setTitleErrorMessage(errorResponseBody.requestError.title)
                }
            }
        } finally {
            this.props.eventEmitter.closeLoading()
        }
    }

    // メッセージ設定(タイトル)
    setTitleErrorMessage(message: string): void {
        this.setState({errorTitleMessage: message})
    }

    // メッセージ取得（タイトル）
    getTitleErrorMessage(): Nullable<ReactElement> {
        if (this.state.errorTitleMessage !== '') {
            return (
                <TitleErrorLabel>
                    {this.state.errorTitleMessage}
                </TitleErrorLabel>
            )
        } else {
            return null
        }
    }

    onClickForgotPassword(): void {
        window.open(HKConstants.CMN.OPC.FLP_FORGET_PASSWORD_MAIL_URL, '_blank')
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        return (
            <>
                <NatStepComponent
                    dIspStepInfo={this.dIspStepInfo}
                    nowStep={Step.SUTEKI_NET_PASSWORD_CONFIRM}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        パスワードの確認
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <MessageBlock>
                    <Message>
                        ご登録いただいたメールアドレスは、既に素敵ネットに登録されています。<br/>
                        パスワードを入力してログインしてください。
                    </Message>
                </MessageBlock>
                {this.getTitleErrorMessage()}
                <WideMainContainer>
                    <BlockSpacer height={'15px'}/>
                    <DisplayBlockDiv>
                        <DisplayItemInputLabelRequired>
                            <DisplayItemInputTitle>メールアドレス</DisplayItemInputTitle>
                            <span style={{marginLeft: '15px'}}>{this.state.token.details?.mailAddress}</span>
                        </DisplayItemInputLabelRequired>
                    </DisplayBlockDiv>
                    <BlockSpacer height={'10px'}/>
                    <DisplayBlockDiv>
                        <DisplayItemInputLabelRequired>
                            <DisplayItemInputTitleRequired>パスワード</DisplayItemInputTitleRequired>
                            <DisplayItemInput
                                type={(this.state.dispPassword === VALID_OR_NOT.NOT.value) ? 'password' : 'text'}
                                name="password"
                                autoComplete={'new-password'}
                                defaultValue={this.state.password}
                                maxLength={16}
                                onChange={this.handleInputChange}
                                autoFocus={true}/>
                            <DisplayCheckItemSelectionLabel>
                                <DisplayCheckItemSelectionName>
                                    <input type="checkbox"
                                           value={this.state.dispPassword}
                                           onChange={this.handlePassworDispTypeChange}/>
                                    パスワードを表示する
                                </DisplayCheckItemSelectionName>
                            </DisplayCheckItemSelectionLabel>
                            <Note>{Messages.IRESR0005.toString('')}</Note>
                            <BlockSpacer height={'20px'}/>
                            <PlainLinkStyledButton onClick={this.onClickForgotPassword}>
                                パスワードを忘れた場合<StyledExternalUrlIcon/>
                            </PlainLinkStyledButton>
                        </DisplayItemInputLabelRequired>
                    </DisplayBlockDiv>
                    <BlockSpacer height={'10px'}/>
                </WideMainContainer>
                <Box height={'15px'}/>
                <Box>メールマガジン配信希望</Box>
                <Box height={'5px'}/>
                <InfosWhiteArea>
                    <Box height={'10px'}/>
                    <Box>
                        <LeftRowFlexContainer>
                            <Checkbox
                                name="wishToHasekoGroupInfos"
                                color="default"
                                checked={(this.state.wishToHasekoGroupInfos !== DO_OR_NOT.NOT.value)}
                                onChange={this.handleInputChange}
                            />
                            長谷工グループ「ブランシエラクラブ」
                        </LeftRowFlexContainer>
                        <InfosContainer>
                            長谷工グループからのお得情報、住まいに関する情報をお届けいたします。（特典、住まいレージポイントサービス、イベント、その他お得なお知らせなど）
                        </InfosContainer>
                        <Box height={'5px'}/>
                    </Box>
                    <Box>
                        <LeftRowFlexContainer>
                            <Checkbox
                                name="sutekiNetOfNotice"
                                color="default"
                                checked={(this.state.sutekiNetOfNotice !== DO_OR_NOT.NOT.value)}
                                onChange={this.handleInputChange}
                            />
                            すてきテラス
                        </LeftRowFlexContainer>
                        <InfosContainer>
                            「すてきテラス」よりマンションに関するサービスのご紹介や暮らしに役立つ情報などを定期的にお届けいたします。
                        </InfosContainer>
                    </Box>
                    <BlockSpacer height={'15px'}/>
                    <Box padding={'0 9px'} fontSize={FontSize.Small} color={Colors.AccentDark}>
                        ※メールマガジン内のリンクよりいつでも配信停止できます。
                    </Box>
                    <BlockSpacer height={'15px'}/>
                </InfosWhiteArea>
                <BlockSpacer height={'30px'}/>
                <PrimaryStyledButton
                    onClick={this.hasekoIdLoginButtonClick}
                    disabled={this.state.hasekoIdLoginButtonFlg}>
                    ユーザ情報の登録確認へ進む
                </PrimaryStyledButton>
                <BlockSpacer height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginSutekiPasswordConfirmPage)

// メッセージブロック
const MessageBlock: StyledDiv = styled.div`
  text-align: center;
`
// メッセージ
const Message = styled(ParagraphText)`
  display: inline-block;
  text-align: left;
`

const InfosWhiteArea = styled.div`
  background-color: ${Colors.Surface};
  ${currentMedia.lessThan('sp')`
    width: calc(100% + 30px);
    margin: 0px -15px;
  `};
  padding: 0 7px;
  box-sizing: border-box;
  overflow: hidden;
`

// 長谷工グループ希望
const InfosContainer: StyledDiv = styled.div`
  padding: 0 15px 0 33px;
  font-size: ${FontSize.Middle};
`

// アイコン
const StyledExternalUrlIcon = styled(OpenInNew)`
  margin-left: 5px;
  vertical-align: sub;
  width: 18px !important;
  height: 18px !important;
`
